module.exports = __webpack_public_path__ + "static/important-loans-dec7132e01eafe8011d31279a83ae1a6.jpg";